import React, { useState, useEffect } from 'react';
import Modal from './Modal';
import { Button } from './Kit';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiAlertTriangle } = FiIcons;

export default function DeleteConfirmModal({ isOpen, onConfirm, onCancel, leadName, isDeleting = false }) {
  const [confirmText, setConfirmText] = useState('');

  useEffect(() => {
    if (!isOpen) setConfirmText('');
  }, [isOpen]);

  const confirmed = confirmText === 'DELETE';

  return (
    <Modal isOpen={isOpen} onClose={onCancel}>
      <div className="flex items-start gap-4">
        <div className="flex-shrink-0 w-10 h-10 bg-red-100 rounded-full flex items-center justify-center">
          <SafeIcon icon={FiAlertTriangle} className="w-5 h-5 text-red-600" />
        </div>
        <div className="flex-1">
          <h2 className="text-base font-semibold text-gray-900">
            Permanently Delete Lead?
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            This will permanently delete{' '}
            <span className="font-medium text-gray-800">{leadName}</span> and all
            associated data including call logs, notes, and assignments.{' '}
            <span className="font-semibold text-red-600">This cannot be undone.</span>
          </p>
          <p className="text-sm text-gray-600 mt-3 font-medium">
            Type <span className="font-mono bg-red-50 text-red-600 px-1.5 py-0.5 rounded">DELETE</span> to confirm:
          </p>
          <input
            type="text"
            value={confirmText}
            onChange={(e) => setConfirmText(e.target.value)}
            placeholder="Type DELETE here"
            className="mt-2 w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent"
            autoFocus
            disabled={isDeleting}
          />
        </div>
      </div>

      <div className="flex justify-end gap-3 mt-6 pt-4 border-t border-gray-100">
        <Button variant="outline" size="sm" onClick={onCancel} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          variant="danger"
          size="sm"
          onClick={onConfirm}
          disabled={!confirmed || isDeleting}
        >
          {isDeleting ? 'Deleting…' : 'Permanently Delete'}
        </Button>
      </div>
    </Modal>
  );
}
